import { render, staticRenderFns } from "./MenuTransition.vue?vue&type=template&id=3e1e4a8a&"
import script from "./MenuTransition.vue?vue&type=script&lang=js&"
export * from "./MenuTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports